interface TokenResponse {
  access_token: string
}

export async function fetchClientToken(): Promise<string | undefined> {
  const url = 'https://uchmc0u1jb.execute-api.us-east-2.amazonaws.com/dcl-client-token'

  try {
    const response = await fetch(url)
    return (await response.json() as TokenResponse).access_token
  } catch (error) {
    console.log(error)
    return undefined
  }
}